module.exports = __webpack_public_path__ + "public-ui/fonts/latin-ext.0f1d3218.woff2";